import React from 'react';
import { Box, Skeleton } from '@mui/material';

const LoadingSkeleton = ({ rows = 4, height = 48 }) => (
  <Box sx={{ width: '100%', p: 2 }}>
    {Array.from({ length: rows }).map((_, index) => (
      <Skeleton
        key={index}
        variant="rounded"
        height={height}
        sx={{ mb: 1.5 }}
      />
    ))}
  </Box>
);

export default LoadingSkeleton;